<template>
  <div>
    <h1>Request Access List</h1>

    <b-table hover small responsive
      :fields="fields"
      :items="requests">
      <template v-slot:cell(actions)="row">
        <b-spinner v-if="isLoading" small></b-spinner>
        <b-button size="sm" @click="approveRequest(row.item)" class="mr-1">
          approve
        </b-button>
		<b-button size="sm" @click="closeRequest(row.item)" class="mr-1">
		  close
		</b-button>
      </template>

      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>

    </b-table>
  </div>
</template>

<script>
  import axios from 'axios';
  import axiosRetry from 'axios-retry';
  import { validationMixin } from 'vuelidate'

  axiosRetry(axios, { retries: 3 });

  export default {
    mixins: [validationMixin],
    title:  'Request Access List',
    data: () => ({
      fields: [
        {key: 'eventDateTime', sortable: false, label: 'Date'},
        {key: 'lphAgencyName', sortable: false, label: 'Agency'},
        {key: 'lphSystemName', sortable: false, label: 'System'},
        {key: 'contactName', sortable: false, label: 'Contact'},
        {key: 'phoneNumber', sortable: false, label: 'Phone'},
        {key: 'emailAddress', sortable: false, label: 'Email'},
        {key: 'actions', label: 'Actions'}
      ],
      isLoading: true,
      requests: [],
      editedIndex: -1,
      options: {
          format: 'YYYY-MM-DD',
          useCurrent: false,
      }
    }),

    validations: {
    },

    components: {
    },

    computed: {
    },

    watch: {
      requests() {
        this.isLoading = false
      }
    },

    created () {
      this.initialize()
    },

    methods: {
      fetchRequests() {
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/admin/datarequest/pending`)
            .then(response => {
                this.requests = response.data;
            })
             .catch(error => { // The first request fails
                 error !== undefined
                 this.$router.push('home')
            })
      },

      initialize () {
          this.fetchRequests()
      },

      approveRequest (item) {
        this.isLoading = true
        axios.post(`${process.env.VUE_APP_IDAM_API_BASE_URL}/user/submitter`, {
          emailAddress: item.emailAddress
        }).then(response => {
            axios.put(`${process.env.VUE_APP_API_BASE_URL}/admin/datarequest/close/${item.id}/${response.data.uuid}`)
              .then(response => {
                this.fetchRequests()
                this.isLoading = false
                this.$bvToast.toast('Approved.', {
                    title: 'Status',
                    toaster: 'b-toaster-top-center',
                    solid: true,
                    variant: 'success',
                    appendToast: true
                  })
              })
        })
             .catch(error => { // The first request fails
                 error !== undefined
                 this.$router.push('home')
            })
      },

      closeRequest (item) {
        this.isLoading = true
        axios.delete(`${process.env.VUE_APP_API_BASE_URL}/admin/datarequest/close/${item.id}`)
             .then(response => {
				this.fetchRequests()
                this.isLoading = false
                this.$bvToast.toast('Request Closed.', {
                    title: 'Status',
                    toaster: 'b-toaster-top-center',
                    solid: true,
                    variant: 'success',
                    appendToast: true
                  })
              })
             .catch(error => { // The first request fails
                 error !== undefined
                 this.$router.push('home')
            })
      },

      save () {
        if (this.editedIndex > -1) {
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/grantees`, this.editedItem)
            .then(response => {
                Object.assign(this.grantees[this.editedIndex], response.data)
                this.$bvToast.toast('Grantee Saved', {
                  title: 'Status',
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: 'success',
                  appendToast: true
                })
            });

        } else {
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/grantees`, this.editedItem)
            .then(response => {
                this.grantees.push(response.data)
                this.$bvToast.toast('Grantee Saved', {
                  title: 'Status',
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: 'success',
                  appendToast: true
                })
            });

        }
        this.close()
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${month}/${day}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      }
    }
  }
</script>